import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/navbar/Header";
import Footer from "./components/navbar/Footer";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Events from "./components/pages/Events";
import Gallery from "./components/pages/gallery";
import Facilities from "./components/pages/Facilities";
import Faculty from "./components/pages/Faculty";
import Enquiry from "./components/pages/Enquiry";
import Insta from "./components/pages/Insta";
import Vision from "./components/pages/Vision";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/Vision" element={<Vision />}></Route>
          <Route path="/Facilities" element={<Facilities />}></Route>
          <Route path="/News&events" element={<Events />}></Route>

          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/Enquiry" element={<Enquiry />}></Route>
          <Route path="/Insta" element={<Insta />}></Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
